// extracted by mini-css-extract-plugin
module.exports = {"container":"YellowBackgroundWithGhostIcon_container__zFZZt"};